import classes from "./index.module.scss";
import { ReactComponent as Play } from "../images/button.svg";
import poster from "../images/poster.jpg";
import Container from "../Container";
import { Popup } from "../../../components/Modal";
import { useState } from "react";
import { useInView } from "react-intersection-observer";

export default function Hero() {
  const { ref, inView } = useInView();

  const [open, setOpen] = useState(false);

  const openVideo = () => setOpen(!open);

  return (
    <section className={classes.section}>
      <Container>
        <div className={classes.body}>
          <div className={classes.content}>
            <h1 className={classes.title}>Who are we?</h1>
            <button onClick={openVideo} className={classes.button}>
              <Play />
              <span>watch video</span>
            </button>
            <div className={classes.text}>
              <p>
                We are a cutting-edge e2e software development company.
                Agilistry has more than 6 years of experience in developing
                high-quality iOS/Android and Web apps and excelling existing
                codebase/infrastructure. We have 62 satisfied clients and 50+
                happy employees. Want to join them?
              </p>
            </div>
          </div>
          <div ref={ref} className={classes.player}>
            <video
              controls={false}
              poster={poster}
              muted
              preload="none"
              playsInline
              loop
              style={{ display: inView ? "flex" : "none" }}
              autoPlay
            >
              <source
                src="https://api.agilistrysoft.com/wp-content/uploads/2022/07/about.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </Container>
      <Popup
        open={open}
        openPopup={openVideo}
        component={
          <div className={classes.modal}>
            <iframe
              src="https://www.youtube.com/embed/rCznpRd_Lr4"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        }
      />
    </section>
  );
}
